import styled from 'styled-components';

export const FAQContainer = styled.div`
  width: 100%;
  margin: 80px 0;
  padding: 0 20px;
  background-color: #111113;
  color: #ffffff;

  @media (max-width: 768px) {
    padding: 0 20px;
  }

`;

export const FAQTitle = styled.h2`
  font-size: 2.5rem;
  text-align: left;
  color: #ffe955;
  margin-bottom: 2rem;
`;

export const FAQItemContainer = styled.div`
  margin-top: 1rem;
`;

export const FAQQuestionButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1rem 0;
  text-align: left;
  font-size: 1.70rem;
  font-weight: 500;
  color: #ffffff;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #333333;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: #ffe955;
  }

  &:focus {
    outline: none;
    color: #ffe955;
  }
`;

export const FAQAnswerPanel = styled.div`
  padding: 1rem 0;
  font-size: 1.125rem;
  line-height: 1.625rem;
  text-align: left;
  color: #cccccc;

  ul {
    padding-left: 1.5rem;  // This adds indentation to the list
  }

  li {
    margin-left: 2.5rem;  // This adds some space between list items
  }

  // Optionally, for nested lists
  ul ul {
    padding-left: 1.5rem;  // This adds extra indentation for nested lists
  }
`;